export const CONFIG = {
    // API_PROD: 'https://api.dinocount.dinocloudevelop.com/',
    API_PROD: 'https://api-dev.dinocount.dinocloudevelop.com/',
};
